import AdminFormLayout from "../../components/common/form-layout/AdminFormLayout";
import { useEffect, useState } from "react";
import { PiArrowDownBold } from "react-icons/pi";
import { getApi } from "../../services/api/globalApi";
import TotalStudent from "./sub-components/TotalStudent";
import TotalLearnTime from "./sub-components/TotalLearnTime";
import TotalLearns from "./sub-components/TotalLearns";
import BioGraphyVideo from "./sub-components/BioGraphyVideo";
import LearnResultGallery from "./sub-components/LearnResultGallery";
import StudentSatisfactionVideo from "./sub-components/StudentSatisfactionVideo";
import BioGraphyText from "./sub-components/BioGraphyText";
import EstelamOllomFonnonLearnVideo from "./sub-components/EstelamOllomFonnonLearnVideo";
import EstelamOllomFonnonLearnWebsiteLink from "./sub-components/EstelamOllomFonnonLearnWebsiteLink";

export default function PublicField() {
  const [accardionToggle, setAccardionToggle] = useState({
    subMenu1: false,
    subMenu2: false,
    subMenu3: false,
    subMenu4: false,
    subMenu5: false,
    subMenu6: false,
    subMenu7: false,
    subMenu8: false,
    subMenu9: false,
  });

  const [data, setData] = useState({});

  const getPublicFieldData = async () => {
    const path = "admin/publicFieldsForFrontUis";
    try {
      const data = await getApi({ path });
      setData(data?.data.result?.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPublicFieldData();
  }, []);

  return (
    <AdminFormLayout title={"مدیریت قسمت های وب سایت"} description="هر بخش از محتوای سایت را باز کنید و اطلاعات همان بخش را ذخیره کنید.">

      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu1: !accardionToggle.subMenu1,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 rounded-t-xl dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تعداد هنرجو ها</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu1 && "hidden"}`}>
            <TotalStudent data={data?.totalStudent} />
          </div>
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu2: !accardionToggle.subMenu2,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>مجموع ساعت آموزش</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu2 && "hidden"}`}>
            <TotalLearnTime data={data?.totalLearnTime} />
          </div>
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu3: !accardionToggle.subMenu3,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تعداد آموزش ها</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu3 && "hidden"}`}>
            <TotalLearns data={data?.totalLearns} />
          </div>
          {/* --------BioGraphyVideo-------------------------------------------------- */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu4: !accardionToggle.subMenu4,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>ویدئو بیوگرافی</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu4 && "hidden"}`}>
            <BioGraphyVideo data={data?.bioGraphyVideo} />
          </div>
          {/* --------BioGraphyText-------------------------------------------------- */}
          {/*  */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu6: !accardionToggle.subMenu6,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-b-0 border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>متن بیوگرافی (صفحه لندینگ)</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu6 && "hidden"}`}>
            <BioGraphyText data={data?.bioGraphyText} />
          </div>
          {/* --------StudentSatisfactionVideo-------------------------------------------------- */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu7: !accardionToggle.subMenu7,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>ویدئو رضایت مشتریان</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu7 && "hidden"}`}>
            <StudentSatisfactionVideo data={data?.studentSatisfactionVideo} />
          </div>
          {/* --------EstelamOllomFonnonLearnVideo -------------------------------------------------- */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu8: !accardionToggle.subMenu8,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>آموزش نحوه استعلام از علوم فنون</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu8 && "hidden"}`}>
            <EstelamOllomFonnonLearnVideo
              data={data?.estelamOllomFonnonLearnVideo}
            />
          </div>
          {/* --------estelamOllomFonnonLearnWebsiteLink-------------------------------------------------- */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu9: !accardionToggle.subMenu9,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>لینک بخش استعلام علوم و فنون</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu9 && "hidden"}`}>
            <EstelamOllomFonnonLearnWebsiteLink
              data={data?.estelamOllomFonnonLearnWebsiteLink}
            />
          </div>
          {/* --------LearnResultGallery-------------------------------------------------- */}
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu5: !accardionToggle.subMenu5,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>عکس های نتایج</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu5 && "hidden"}`}>
            <LearnResultGallery data={data?.learnResultGallery} />
          </div>
        </div>
      </div>
    </AdminFormLayout>
  );
}
